import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField } from '../../components/ui';
import { useForgotPassword } from '../../hooks/react-query/useUserData';
import { SpinnerIcon } from '../../icons';

const ForgotPassword = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [error, setError] = useState('');

  const { mutate: handlePasswordSubmit, isLoading } = useForgotPassword();

  const handleSubmit = (event) => {
    // navigate('/');
    event.preventDefault();
    handlePasswordSubmit(username, {
      onSuccess: (data) => {
        if (data && data.data.status === 'fail') {
          if (data.exceptions && data.exceptions.length) {
            setError(data.exceptions[0]);
          }
        } else {
          navigate('/');
        }
      },
    });
  };

  return (
    <div
      className="w-[100vw] flex items-center justify-center overflow-hidden"
      style={{ height: 'calc(100vh - 72px)' }}
    >
      <form
        onSubmit={handleSubmit}
        className="flex flex-col items-center justify-center gap-8 lg:px-44 lg:bg-white rounded-[20px] py-10"
      >
        <div className='flex flex-col gap-2 items-center'>
          <h2 className="">Ξέχασες τον κωδικό σου;</h2>
          <p className='text-label w-9/12 text-center'>Συμπλήρωσε το email σου και θα λάβεις οδηγίες για να ορίσεις νέο κωδικό.</p>
        </div>
        <div className="flex flex-col gap-8 items-center">
          <TextField
            value={username}
            onChange={(e) => {
              error && setError('');
              setUsername(e.target.value);
            }}
            className={
              'p-2 border border-[#A5A5A5] rounded-[8px] w-72 lg:text-black text-grenite'
            }
            label={'Email'}
            placeholder={''}
            id="email"
            error={error}
          />
          <div className="flex gap-3 max-lg:flex-col max-lg:flex-col-reverse max-lg:w-full">
            <button
              type="button"
              className="btn-secondary"
              onClick={() => navigate('/')}
            >
              Ακύρωση
            </button>

            <button type="submit" disabled={!username} className="btn-primary">
              {isLoading && <SpinnerIcon />} Υποβολή
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ForgotPassword;
